module.exports = __webpack_public_path__ + "img/star-full.86ebbfa1.svg";